(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anton-buy-box"] && !Shopify.designMode) return;
  try {
    
  // Gallery: keeps the dot indicators in sync with whichever slide is in
  // view. Uses IntersectionObserver against the scroll track so the
  // active state updates while the user swipes (no scroll-listener noise).
  (function () {
    var galleries = document.querySelectorAll('[data-anton-gallery]');
    galleries.forEach(function (gallery) {
      var track = gallery.querySelector('.anton-buy-box__gallery-track');
      var slides = gallery.querySelectorAll('.anton-buy-box__gallery-slide');
      var dots = gallery.querySelectorAll('.anton-buy-box__gallery-dot');
      if (!track || !slides.length || !dots.length) return;

      function setActive(idx) {
        dots.forEach(function (dot, i) {
          var active = i === idx;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      // Clicking a dot scrolls the *track* (not the page), so we don't
      // trigger a URL-fragment jump that could yank the viewport.
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          var slide = slides[i];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActive(i);
        });
      });

      // IntersectionObserver against the scroll track sees which slide is
      // most visible and updates the active dot.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10);
            if (!isNaN(idx)) setActive(idx);
          }
        });
      }, { root: track, threshold: [0.6, 0.8, 0.99] });

      slides.forEach(function (slide) { io.observe(slide); });
    });
  })();

  // Quantity steppers + live price totals (qty × unit price).
  (function () {
    function clampQty(value) {
      var n = parseInt(value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function formatMoney(cents) {
      if (!cents || cents < 0) return '';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents);
        } catch (e) {}
      }
      var dollars = cents / 100;
      if (Math.abs(dollars - Math.round(dollars)) < 0.001) {
        return '$' + Math.round(dollars).toLocaleString('en-US');
      }
      return '$' + dollars.toFixed(2);
    }

    function syncPrices(box, qty) {
      if (!box) return;
      var unit = parseInt(box.getAttribute('data-unit-price-cents') || '0', 10);
      var compare = parseInt(box.getAttribute('data-unit-compare-cents') || '0', 10);
      if (!unit) return;
      var priceText = formatMoney(unit * qty);
      var compareText = compare > 0 ? formatMoney(compare * qty) : '';
      box.querySelectorAll('[data-anton-live-price]').forEach(function (el) {
        el.textContent = priceText;
      });
      box.querySelectorAll('[data-anton-live-compare]').forEach(function (el) {
        if (compareText) {
          el.textContent = compareText;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    }

    function syncDec(control) {
      var input = control.querySelector('.anton-buy-box__qty-input');
      var dec = control.querySelector('[data-anton-qty-dec]');
      if (!input || !dec) return;
      dec.disabled = clampQty(input.value) <= 1;
    }

    document.querySelectorAll('[data-anton-qty]').forEach(function (wrap) {
      if (wrap.dataset.antonQtyBound === '1') return;
      wrap.dataset.antonQtyBound = '1';
      var box = wrap.closest('.anton-buy-box');
      var control = wrap.querySelector('.anton-buy-box__qty-control');
      var input = wrap.querySelector('.anton-buy-box__qty-input');
      var dec = wrap.querySelector('[data-anton-qty-dec]');
      var inc = wrap.querySelector('[data-anton-qty-inc]');
      if (!control || !input) return;

      function refresh() {
        var qty = clampQty(input.value);
        input.value = String(qty);
        syncDec(control);
        syncPrices(box, qty);
      }

      syncDec(control);
      syncPrices(box, clampQty(input.value));

      if (dec) {
        dec.addEventListener('click', function () {
          input.value = String(clampQty(Number(input.value) - 1));
          refresh();
        });
      }
      if (inc) {
        inc.addEventListener('click', function () {
          input.value = String(clampQty(Number(input.value) + 1));
          refresh();
        });
      }
      input.addEventListener('change', refresh);
      input.addEventListener('input', refresh);
    });
  })();

  // Add to cart via /cart/add.js so the theme editor (and SPA preview)
  // does not navigate away on a full-page /cart/add redirect.
  //
  // This store's PRIMARY market is Cyprus (often without shipping/catalog).
  // Visitors in CY get a misleading "sold out" from /cart/add.js. We force
  // the US market (where the product is sellable) before adding.
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function showError(errorEl, msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      errorEl.style.color = '#b42318';
    }

    function withTimeout(promise, ms) {
      return Promise.race([
        promise,
        new Promise(function (resolve) {
          setTimeout(function () { resolve(null); }, ms);
        })
      ]);
    }

    function ensureUsMarket() {
      // Prefer JSON localization; fall back to form-encoded. Never block checkout.
      var jsonAttempt = fetch(root + 'localization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          country_code: 'US',
          country: 'US',
          language_code: 'en',
          language: 'en'
        }),
        credentials: 'same-origin'
      }).catch(function () {
        return null;
      }).then(function () {
        var body = new URLSearchParams();
        body.set('country_code', 'US');
        body.set('language_code', 'en');
        return fetch(root + 'localization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'text/html'
          },
          body: body.toString(),
          credentials: 'same-origin'
        }).catch(function () {
          return null;
        });
      });
      return withTimeout(jsonAttempt, 2500);
    }

    function addToCart(variantId, qty) {
      var addUrl = root + 'cart/add.js';
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      }).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        }).catch(function () {
          return { ok: res.ok, data: {} };
        });
      }).then(function (result) {
        if (result.ok) return result;
        return fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: qty }]
          })
        }).then(function (res2) {
          return res2.json().then(function (data2) {
            return { ok: res2.ok, data: data2 };
          });
        });
      });
    }

    function goTo(url) {
      try {
        window.location.assign(url);
      } catch (e) {
        window.location.href = url;
      }
    }

    document.querySelectorAll('[data-anton-add-to-cart]').forEach(function (form) {
      if (form.dataset.antonCartBound === '1') return;
      form.dataset.antonCartBound = '1';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var errorEl = form.querySelector('[data-anton-cart-error]');
        var button = form.querySelector('.anton-buy-box__cta');
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var returnInput = form.querySelector('[name="return_to"]');
        var variantId = idInput && idInput.value;
        var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        if (qty > 99) qty = 99;
        if (qtyInput) qtyInput.value = String(qty);

        var afterAdd = (form.getAttribute('data-after-add') || 'cart').toLowerCase();
        var cartUrl = form.getAttribute('data-cart-url') || '/cart';
        var checkoutUrl = form.getAttribute('data-checkout-url') || '/checkout';
        var nextUrl = afterAdd === 'checkout' ? checkoutUrl : cartUrl;
        if (returnInput) returnInput.value = nextUrl;

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        if (!variantId) {
          showError(errorEl, 'This product is unavailable right now.');
          return;
        }

        // Spec: Click Checkout / Buy → dataLayer event "checkout"
        if (afterAdd === 'checkout' && window.RHBandDL && typeof window.RHBandDL.checkoutClick === 'function') {
          try {
            window.RHBandDL.checkoutClick({
              item_id: form.getAttribute('data-dl-sku') || '',
              item_name: form.getAttribute('data-dl-item-name') || '',
              price: form.getAttribute('data-dl-price'),
              currency: form.getAttribute('data-dl-currency') || 'USD',
              quantity: qty,
              payment_method: 'shopify',
              payment_type: 'credit_card'
            });
          } catch (e) {}
        }

        if (button) {
          button.disabled = true;
          button.setAttribute('data-anton-busy', '1');
        }

        function unlockButton() {
          if (!button) return;
          button.disabled = false;
          button.removeAttribute('data-anton-busy');
        }

        ensureUsMarket()
          .then(function () {
            return addToCart(variantId, qty);
          })
          .then(function (result) {
            if (!result || !result.ok) {
              var raw = (result && result.data && (result.data.description || result.data.message)) || '';
              var msg = raw;
              if (/sold out/i.test(raw)) {
                msg = 'Could not add to cart for your current market/shipping setup. Switch the store country to United States (footer country selector), or in Admin set US as the primary market and ensure shipping is enabled.';
              } else if (!msg) {
                msg = 'Could not add this product to the cart.';
              }
              showError(errorEl, msg);
              unlockButton();
              // Last resort: native cart/add + return_to (always leaves the page).
              goTo(
                root +
                  'cart/add?id=' +
                  encodeURIComponent(variantId) +
                  '&quantity=' +
                  encodeURIComponent(String(qty)) +
                  '&return_to=' +
                  encodeURIComponent(nextUrl)
              );
              return;
            }

            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            goTo(nextUrl);
          })
          .catch(function () {
            unlockButton();
            goTo(
              root +
                'cart/add?id=' +
                encodeURIComponent(variantId) +
                '&quantity=' +
                encodeURIComponent(String(qty)) +
                '&return_to=' +
                encodeURIComponent(nextUrl)
            );
          });
      });
    });

    // Browser Back from checkout restores this page from bfcache with the CTA
    // still disabled (grey). Clear the busy state whenever the page is shown.
    function unlockBusyCtas() {
      document.querySelectorAll('.anton-buy-box__cta[data-anton-busy="1"]').forEach(function (btn) {
        btn.disabled = false;
        btn.removeAttribute('data-anton-busy');
      });
    }
    window.addEventListener('pageshow', unlockBusyCtas);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') unlockBusyCtas();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
